var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAwardsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2187_3766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0085 9.52913C21.0085 14.5158 16.966 18.5583 11.9793 18.5583C6.99268 18.5583 2.9502 14.5158 2.9502 9.52913C2.9502 4.54248 6.99268 0.5 11.9793 0.5C16.966 0.5 21.0085 4.54248 21.0085 9.52913Z",
    fill: "#0052FD",
    stroke: "#0052FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25921 15.104L0.980469 20.7875L4.80724 20.5843L6.54582 24.0001L9.57889 18.7418C7.40567 18.1796 5.53952 16.871 4.25921 15.104ZM19.7175 15.0757C18.4466 16.8473 16.5805 18.1607 14.412 18.7324L17.4545 24.0001L19.1931 20.5843L23.0198 20.7875L19.7175 15.0757Z",
    fill: "#0052FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9794 16.4362C15.794 16.4362 18.8864 13.3438 18.8864 9.52916C18.8864 5.71448 15.794 2.62207 11.9794 2.62207C8.16467 2.62207 5.07227 5.71448 5.07227 9.52916C5.07227 13.3438 8.16467 16.4362 11.9794 16.4362Z",
    fill: "#0052FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7128 8.78267C16.9254 8.5748 16.8073 8.21102 16.5144 8.1685L13.7884 7.77165C13.6703 7.75275 13.5711 7.68189 13.5191 7.57323L12.3002 5.10236C12.1679 4.83307 11.7853 4.83307 11.653 5.10236L10.4388 7.57323C10.3868 7.67716 10.2829 7.75275 10.1695 7.77165L7.44352 8.1685C7.15061 8.21102 7.0325 8.5748 7.2451 8.78267L9.21517 10.7055C9.30021 10.7905 9.33801 10.9087 9.31911 11.022L8.85612 13.7339C8.80415 14.0268 9.11596 14.2535 9.38053 14.1118L11.8183 12.8315C11.9223 12.7748 12.0498 12.7748 12.1538 12.8315L14.5916 14.1118C14.8561 14.2488 15.1632 14.0268 15.116 13.7339L14.6482 11.022C14.6293 10.9039 14.6671 10.7858 14.7522 10.7055L16.7128 8.78267Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2187_3766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardsIcon);
export default __webpack_public_path__ + "static/media/AwardsIcon.9b92baf0b91e8288d7197f59de1765ea.svg";
export { ForwardRef as ReactComponent };